
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/pagalba",
      function () {
        return require("private-next-pages/lt/sub/pagalba.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/pagalba"])
      });
    }
  